import askForLeavingWithoutSavingChanges from '../../../../core/helpers/routing/ask-for-leaving-without-saving-changes';
import ticketTemplateModelReducer from '../../reducers/ticket-template-model-reducer';

export default class TicketTemplateEditController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        askForLeavingWithoutSavingChanges(this);

        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.stateParams = this.injector.get('$stateParams');
        this.navService = this.injector.get('NavService');
        this.alert = this.injector.get('Alert');
        this.workflows = this.injector.get('Workflows');
        this.translate = this.injector.get('$translate');

        this.mediaDirectoryUuid = _.get(this.injector.get('Users'), 'state.company.media.default_directories.tickets', null);

        this.submitting = false;
        this.showTicketTemplatePreview = false;

        this.currentView = 'pdf';

        this.allowRoute = false;
        this.ticketTemplate = null;
        this.model = {
            name: '',
            template: '',
            type: 'default',
            pdf_options: {
                'page-height': '120mm',
                'page-width': '240mm',
                'margin-top': '0mm',
                'margin-left': '0mm',
                'margin-right': '0mm',
                'margin-bottom': '0mm',
                'text': {
                    'size': '4mm',
                    'top': '40mm',
                    'left': '80mm',
                    'color': '#000000'
                },
                'qr_code': {
                    'size': '53mm',
                    'top': '35mm',
                    'left': '17mm'
                }
            },
            background_image: null
        };
        this.originalModel = _.cloneDeep(this.model);

        this.loading = true;

        this._updateNavigation();
        this._prepareFormConfig();
        this._initWatchers();

        this._loadTemplate().then((template) => {
            this.loading = false;
        });
    }

    _loadTemplate() {
        return this.api.get(`tickets/templates/${this.stateParams.id}`).then((response) => {
            this.model = ticketTemplateModelReducer(response.data.data);
            this.originalModel = _.cloneDeep(this.model);
            this.ticketTemplate = _.cloneDeep(response.data.data);
            this._updateNavigation();

            return _.cloneDeep(this.ticketTemplate);
        }, () => {
            this.alert.error('Error', 'Error while loading bookable object');
            this.state.back();
        });
    }

    updateModel(newModel) {
        if (!_.isEqual(this.model, newModel)) {
            this.model = newModel;
        }
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.model,
            () => this.allowRoute = _.isEqual(this.model, this.originalModel),
            true
        );
    }

    _updateNavigation() {
        this._updateCustomActions();

        if (!this.ticketTemplate) {
            return;
        }

        this.navService.setBreadcrumbParameters({
            ticket_template_name: this.ticketTemplate.name
        });
    }

    _prepareFormConfig() {
        this.formConfig = {
            templateAce: null
        };

        this.injector.get('AceEditor').getEditor((editor) => {
            this.formConfig.templateAce = editor;
        });
    }

    submit(form) {
        if (this.submitting) {
            return;
        }

        if (!form.$valid) {
            this.alert.error('Validation', 'Please check all fields');
            _.each(form.$error, (field) => {
                _.each(field, (errorField) => {
                    errorField.$setTouched();
                })
            });
            return;
        }

        this.submitting = true;

        this.sendSubmit().finally(() => {
            this.submitting = false;
        });
    }

    _updateCustomActions() {
        let workflows = this.workflows.getWorkflows('tickets::templates-details')
            .filter(workflow => {
                return this.workflows.shouldShow(this.ticketTemplate, workflow) && this.ticketTemplate && (this.ticketTemplate.archived ? workflow.level === 'archived-highlight' : workflow.level === 'highlight');
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }
                workflow.action = () => {
                    workflow.onClick(this.ticketTemplate, this);
                };

                return workflow;
            });

        this.navService.overrideMainSideNavActions(workflows);
    }

    sendSubmit() {
        return this.api.put(`tickets/templates/${this.ticketTemplate.id}`, this.model)
            .then((response) => {
                this.model = ticketTemplateModelReducer(response.data.data);
                this.originalModel = _.cloneDeep(this.model);
                this.ticketTemplate = _.cloneDeep(response.data.data);
                this._updateNavigation();

                this.alert.success(
                    this.translate.instant('general.alerts.change_save_success.title'),
                    this.translate.instant('general.alerts.change_save_success.content')
                );
            }, (response) => {
                this.alert.handle(response);
            });
    }

    closeView() {
        this.state.go('app.tickets.templates.index');
    }
}

TicketTemplateEditController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/controllers/pages/edit-controller.js